exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-wrapper{aspect-ratio:16/9}.border-container-chart #line-chart{padding-top:.5rem;border:1px solid hsla(0,0%,59.2%,.2)}", ""]);

// exports
